import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10020View from "../../Views/Bases/BM10020";
import Snackbar from "../../Components/Snackbar";

function BM10020(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [authGroup, setAuthGroup] = React.useState("");
  const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
  const [modalToggle, setModalToggle] = React.useState(false);
  const [checkInputs, setCheckInputs] = React.useState({
    value1: "",
    result: false,
  });
  const [inputs, setInputs] = React.useState({
    comboPlantList: [],
    comboInwh: [],
  });
  let AuthGroup = "";
  const [checkUserIdToggle, setCheckUserIdToggle] = React.useState(false);
  const [saveUserId, setSaveUserId] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
        inputs.comboPlantList = getComboData.filter(
          (e) => e.groupCd == "PLANT_CD"
        );
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10020.GetMember
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            plantNm: data[i].plantNm,
            authGroupCd: data[i].authGroupCd,
            authMember: data[i].authMember,
            userId: data[i].userId,
            userNm: data[i].userNm,
            useYn: data[i].useYn === "Y" ? true : false,
            createId: data[i].createId,
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
          });
        }
        setRowData(getRowData);
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetGroup = async () => {
    Dialog.ProgressBar(true);
    let getData = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10020.GetGroup
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getData.push({
            authGroupCd: data[i].authGroupCd,
            authGroupNm: data[i].authGroupNm,
          });
        }

        setAuthGroupGridRowData(getData);
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Print = async (e) => {
    let headerData = [];
    let tableData = [];
    let address;

    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

    //address = "http://114.206.84.134:5540/Bases/User_BarCode"; //http://localhost:65061/ 114.206.84.134:5540
    address = "https://dongsungprintingmes.com:8082/Bases/User_BarCode"; //http://localhost:65061/ 114.206.84.134:5540

    headerData.push({
      ReportTitle: "사용자 바코드",
      UserId: e.data.userId,
    });
    var f = document.createElement("form");
    f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
    f.method = "POST";
    f.target = "_blank";

    var k = document.createElement("input");
    k.type = "hidden";
    k.name = "headerData";
    k.value = JSON.stringify(headerData);
    f.append(k);

    var l = document.createElement("input");
    l.type = "hidden";
    l.name = "tableData";
    l.value = JSON.stringify(tableData);
    f.append(l);
    document.body.appendChild(f);
    f.submit();
  };

  const CreateGroupMember = async (_param = []) => {
    Dialog.ProgressBar(true);
    let pushData = [];
    let userInfo = null;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < _param.authGroupCd.length; i++) {
        pushData.push({
          userId: _param.userId,
          authGroupCd: _param.authGroupCd[i],
          createDate: new Date(),
          createId: userInfo.userId,
          updateDate: new Date(),
          updateId: userInfo.userId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10020.CreateGroupMember,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          throw new Error(data);
        } else {
          // setSnackbars({
          //   toggle: true,
          //   type: "success",
          //   message: "저장되었습니다.",
          // });
          SaveLogic();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckUserId = async () => {
    Dialog.ProgressBar(true);

    if (checkInputs.value1 === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_CheckId" && f.lanType === "SNACK"
        )[0].lanName,
      });
      Dialog.ProgressBar(false);
      return;
    }

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10020.CheckUserId,
        {
          UserId: checkInputs.value1,
        }
      ).then((result) => {
        let data = result.data;
        if (data === true) {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokId" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setCheckInputs({
            ...checkInputs,
            result: true,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoId" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let upDateGetData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < updateData.length; i++) {
        if (updateData[i].plantNm == undefined) {
          throw new Error("사업장을 선택하세요.");
        }
        upDateGetData.push({
          plantCd: updateData[i].plantNm.value,
          userId: updateData[i].userId,
          userNm: updateData[i].userNm,
          password: "1234",
          useYn: updateData[i].useYn === true ? "Y" : "N",
          createDate: new Date(),
          createId: userInfo.userId,
          updateDate: new Date(),
          updateId: userInfo.userId,
        });
      }
      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10020.CreateMember,
        updateData.length === 0 ? saveUserId : upDateGetData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10020.Delete,
          {}
        ).then((result) => {
          let data = result.data;

          if (data !== "Ok") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: data,
            });
          } else {
            Init();
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const UpdatePassword = async (_userInfo) => {
    Dialog.ProgressBar(true);
    try {
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10020.UpdatePassword,
        {
          userId: _userInfo.userId,
          userNm: _userInfo.userNm,
          password: "string",
          createDate: _userInfo.createDate,
          createId: _userInfo.createId,
          updateDate: _userInfo.updateDate,
          updateId: _userInfo.updateId,
        }
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UpDatePassword" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <Bm10020View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        UpdatePassword={UpdatePassword}
        SaveConfirm={SaveConfirm}
        setChangedRowData={setChangedRowData}
        DeleteConfirm={DeleteConfirm}
        GetGroup={GetGroup}
        authGroup={authGroup}
        AuthGroup={AuthGroup}
        setSelectedRowData={setSelectedRowData}
        setModalToggle={setModalToggle}
        checkUserIdToggle={checkUserIdToggle}
        CheckUserId={CheckUserId}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        authGroupGridRowData={authGroupGridRowData}
        CreateGroupMember={CreateGroupMember}
        saveUserId={saveUserId}
        setSaveUserId={setSaveUserId}
        Print={Print}
        inputs={inputs}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10020;
